export default __webpack_public_path__ + "static/media/G0006.b279dd3f.png";